import React from "react";
import { IFundSection } from "./SecondaryNav.types";

export function setSecondaryNavState(fundSections: IFundSection[], setFundSections: React.Dispatch<React.SetStateAction<IFundSection[]>>, selectedSectionIds: String[], activeClass: String) {
  //get all section names
  const allValidSectionIDs = fundSections.map(fundSection => fundSection.id);
  //set the react state
  setFundSections(currentFundSections => {
    return [...currentFundSections].map(section => {
      if (selectedSectionIds.includes(section.id)) {
        return {
          ...section,
          activeClass: activeClass
        }
      }
      return section;
    })
  });

  if (activeClass != "active") return;

  /**
   * Set the browser history state
   */

  const currentState = window.history.state?.section ?? "";

  //only the last one is set as the current url state
  const selectedSectionId = selectedSectionIds[selectedSectionIds.length - 1];

  //If the user is traversing though the history stack (i.e. back and forward buttons), we should not push a state. The state should already be there and should be the current state.
  if (currentState == selectedSectionId) return;

  const newUrl = getCleanPageURL(fundSections) + "/" + selectedSectionId;

  // ensure that there is always the ending slash when injecting the new section URL to history
  const fullNewUrl = (newUrl.endsWith("/") ? newUrl : `${newUrl}/`)+ window.location.search + window.location.hash;
  window.history.pushState({ section: selectedSectionId }, "", fullNewUrl);

  //set the title
  const allValidSectionNames = fundSections.map(x => x.name);
  const newSectionName = fundSections.find(x => x.id == selectedSectionId)?.name ?? "";
  let newTitle = document.title;
  allValidSectionNames.forEach(name => {
    if (name == null) return;
    newTitle = newTitle.replace(name as string, newSectionName as string);
  });
  if (!newTitle.includes(newSectionName as string)) {
    newTitle = newTitle.replace("| VanEck", newSectionName as string + " | VanEck");
  }
  document.title = newTitle;
}

export function forceSetOverview(Sections: IFundSection[], setFundSections: React.Dispatch<React.SetStateAction<IFundSection[]>>) {
  
  const SectionsAlreadyActive = Array.from(document.querySelectorAll(".sidebar-nav__item.active")).map(
    (x) => (x as HTMLElement).dataset.target
  );
  if (SectionsAlreadyActive.length > 0) return; //something is already active
  
  //get the first section
  const firstSection = document.getElementsByClassName("fund-page-section")[0]
  if (!firstSection) return;

  setSecondaryNavState(Sections, setFundSections, [firstSection.id ?? ""], "active");
}

export function getCleanPageURL(fundSections: IFundSection[]) {
    //Get all the valid section IDs
    const allValidSectionIDs = fundSections.map(fundSection => fundSection.id);
    //get all the path tokens and reverse it to speed up search
    let pathtokens = window.location.pathname.split("/").reverse();

    //see if the any of the token match the available indexes.
    const currentSection = allValidSectionIDs.find(section => pathtokens.find(x => x == section));
    if (currentSection) {
        //replace any current path token (current section) with an empty string.
        pathtokens.forEach((token, index) => {
            if (token != currentSection) return;
            pathtokens[index] = "";
        })
    }

    pathtokens.reverse();
    if (pathtokens[pathtokens.length - 1] == "") pathtokens.pop(); // = remove trailing slash
    const url = pathtokens.join("/");

    const newUrl = url.endsWith("/") ? url.slice(0, url.length-1) : url;

    return newUrl;
}